import React, { memo } from 'react'

import { Icon, ImageAI } from '@cgtrader/triangle-ui/dist/src/ssr-index'

const LOADING_ICON_SIZE = { width: '40px', height: '40px' }
const loadingIcon = <Icon svgComponent={ImageAI} size={LOADING_ICON_SIZE} color="dark" notSpaced />

// Loading turn: "Creating your image..." label above a shimmering placeholder.
function GeneratingState() {
  return (
    <div className="image-assistant-panel__generating">
      <p className="image-assistant-panel__generating-label cgt-body-base">Creating your image...</p>
      <div className="image-assistant-panel__loading-card">{loadingIcon}</div>
    </div>
  )
}

export default memo(GeneratingState)
